module.exports = __webpack_public_path__ + "static/img/oca-culture-report.4afcd6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/oca-culture-report.jpg
// module id = toXe
// module chunks = 0